import { render, staticRenderFns } from "./LiquidacionDetalle.vue?vue&type=template&id=1b03535a"
import script from "./LiquidacionDetalle.vue?vue&type=script&lang=ts"
export * from "./LiquidacionDetalle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports